import React from 'react';

import Login from '../base/youagain';
import Roles from '../base/Roles';
import Misc from '../base/components/Misc';
import { noVal } from '../base/utils/miscutils';


function JoinUsPage() {
	if (!Login.isLoggedIn()) {
		return (
			<div className="">
				<h1>Join Us!</h1>
				
				<a href="https://good-loop.com/contact" className="btn btn-link m-2">Brand</a>

				<a href="https://good-loop.com/contact" className="btn btn-link m-2">Agency</a>

				{/* <a href="/#adsignup" className="btn btn-primary m-2">Small Business Advertiser</a> */}

				<a href="https://good-loop.com/publishers" className="btn btn-link m-2">Publisher</a>

				<a href="https://good-loop.com/charities" className="btn btn-link m-2">Charity</a>

				<img src="http://www.teara.govt.nz/files/p1125atl.jpg" />
			</div>
		);
	}

	const canAdmin = Roles.iCan('admin').value;
	if (noVal(canAdmin)) return <div><Misc.Loading /></div>;

	if (canAdmin) {
		return (
			<div>
				<h2>Joining Us: Account Authorised :)</h2>
				<h3>Great you've registered and you're authorised! You're good to go :)</h3>
				<img src="http://www.teara.govt.nz/files/p1125atl.jpg" />
			</div>
		);
	}

	return (
		<div>
			<h2>Joining Us: Account Authorisation</h2>
			<h3>Great you've registered! Contact Amy or Dan to get your account authorised.</h3>
			<img src="http://www.teara.govt.nz/files/p1125atl.jpg" />
		</div>
	);
}// ./JoinUsPage


export default JoinUsPage;
